// extracted by mini-css-extract-plugin
export default {"issueTypeDot":"DefaultIssueTypePickerAnchor-module__issueTypeDot--KX5Dc"};